import { Box, CircularProgress } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { selectUserState } from 'shared/redux/slicers/user.slicer';
import { opportunitiesServices } from 'shared/services/opportunitiesServices';
import { projectService } from 'shared/services/projectService';
import { tokenService } from 'shared/services/tokenService';
import { ls } from 'shared/utils/ls';

const { getSingleProjectGQL } = projectService();
function CheckInRedirect() {
  const { projectId, option, roleId } = useParams() as { projectId: string; option: string; roleId: string };
  const { data, isLoading } = getSingleProjectGQL(projectId);
  const { isAuthenticated } = tokenService();
  const history = useHistory();
  const { setLS, clearLS, removeLS } = ls();

  useEffect(() => {
    if (isLoading) return;

    if (isAuthenticated()) {
      setLS('projectId', projectId);
      setLS('option', option);
      if (roleId) setLS('roleId', roleId);
      else removeLS('roleId');

      setTimeout(() => {
        history.push(`/talent/${option}/${projectId}`);
      }, 1000);
    } else {
      // history.push(`/new-talent/${option}/${projectId}`);
      clearLS();

      if (data?.data.project) {
        console.log('data', data.data);
        setLS('project_name', data?.data?.project?.name);
        setLS(
          'project_roles',
          JSON.stringify(
            data?.data?.project.casting_roles.map((role) => {
              return { value: role.id, key: role.name };
            }),
          ),
        );
      }
      setLS('projectId', projectId);
      setLS('option', option);
      setTimeout(() => {
        history.push(`/login`);
      }, 1000);
    }
  }, [isAuthenticated, projectId, history, option, isLoading, data]);

  return (
    <Box style={{ width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <CircularProgress style={{ width: 30, height: 30, marginRight: 10 }} />
      Redirecting...
    </Box>
  );
}

export default CheckInRedirect;
